export default __webpack_public_path__ + "static/amazon-sqs-ab56c7e3b3dce446f59caf0932f431bf.svg";